import type { Scope } from '@openclassrooms/auth-sdk';

const AppScopes = {
  CONNECTED: [
    'user_email',
    'user_public_profile',
    'user_learning_activity',
    'learning_content',
    'user_birth_information',
    'user_communications',
    'user_calendar',
    'organization',
    'user_interest',
    'openclassrooms_client',
  ],
  ANONYMOUS: ['learning_content', 'openclassrooms_client'],
} as const satisfies Record<string, Scope[]>;

export default AppScopes;
